export const MAIN_MENU = {
  Debates: 'Debates',
  Challenges: 'Challenges',
  Help: 'Help',
  About: 'About',
  Profile: 'Profile',
} as const;

export const LIVE_MENU = {
  Live: 'Live',
} as const;

export const MY_MENU = {
  Profile: 'Profile',
  MyChallenges: 'My challenges',
  MyDebates: 'My debates',
  Help: 'Help',
  SignOut: 'Sign out',
} as const;

export const CHALLENGE_CARD_MENU_INITIATOR = {
  CancelChallenge: 'Cancel challenge',
} as const;

export const DEBATE_CARD_MENU_INITIATOR = {
  CancelDebate: 'Cancel debate',
} as const;

export const DEBATE_CARD_MENU_OPPONENT = {
  CancelDebate: 'Quit debate',
} as const;
